import React, { useState } from "react";
import { Typography, Button, Grid, TextField, Snackbar, Alert, CircularProgress, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Layout from "./UserLayout";
import { formFieldStyles, labelStyles } from "../../styles/formStyles";
import { resetPassword } from "../../services/User";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = (): boolean => {
    if (!email) {
      setError("Email is required");
      return false;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError("Enter a valid email");
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await resetPassword(email);
      console.log("reset Res:",res)
      if (res && res.status === "success"){
        navigate("/otp-verification", {
          state: { email, status: "forgot" },
        });
      }
      else if(res && res.status === "error"){
        const errMsg = res.errorResponse?.response?.data.message || res.errorResponse?.message || "Failed to send otp.";
        setErrMsg(errMsg);
        setOpenError(true);
      }
    } catch (err: any) {
      setErrMsg(err.message || "Email not found");
      setOpenError(true);
    } finally {
      setLoading(false);
    }
  };
  const handleSnackbarClose = () => {
    setOpenError(false);
  };
  return (
    <Layout>
      <Typography variant="h5" mb={1.5}>
        Reset your password
      </Typography>
      <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography component="label" sx={labelStyles}>
              Email Address <span style={{ color: "#FE0909" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!error}
              helperText={error}
              sx={formFieldStyles}
            />
          </Grid>

          <Grid item xs={12}>
            {!loading && (
            <Button
            onClick={handleSubmit}
            fullWidth
            sx={{
              borderRadius: "6px",
              background: "#005EFF",
              color: "#fff",
              fontWeight: 600,
              py: 1,
              textTransform: "none",
              "&:hover": {
                background: "#0047cc",
              },
            }}
            endIcon={<ArrowForwardIcon />}
          >
            Send OTP
          </Button>
            )}
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
              </Box>
            )}
          </Grid>

          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate("/login")}
              sx={{
                textTransform: "none",
              }}
            >
              Back to Login
            </Button>
          </Grid>
        </Grid>

      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openError} autoHideDuration={5000} onClose={handleSnackbarClose}>
        <Alert severity="error" variant="filled" sx={{ width: "100%" }}>{errMsg}</Alert>
      </Snackbar>
    </Layout>
  );
};

export default ResetPassword;
